import React, { useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { useUser } from './UserContext';
import { toast } from 'react-toastify';

const BACKEND_API_URL = 'https://tripoptimizebackend.onrender.com';

const FeedbackContainer = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  color: #2c3e50;
  margin-bottom: 2rem;
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 200px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 1rem;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #3498db;
  }
`;

const SubmitButton = styled.button`
  background-color: #3498db;
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  width: 100%;
  transition: all 0.2s;
  
  &:hover {
    background-color: #2980b9;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #bdc3c7;
    cursor: not-allowed;
    transform: none;
  }
`;

const Feedback = () => {
  const { user } = useUser();
  const [feedback, setFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!feedback.trim()) {
      toast.error('Please enter your feedback');
      return;
    }

    setIsSubmitting(true);

    try {
      await axios.post(
        `${BACKEND_API_URL}/submit-feedback`,
        { user_feedback: feedback },
        {
          headers: { Authorization: `Bearer ${user.token}` }
        }
      );
      
      toast.success('Thank you for your feedback!');
      setFeedback('');
    } catch (error) {
      toast.error('Error submitting feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FeedbackContainer>
      <Title>Submit Feedback</Title>
      <form onSubmit={handleSubmit}>
        <TextArea
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="We value your feedback! Please share your thoughts, suggestions, or report any issues you've encountered..."
          disabled={isSubmitting}
        />
        <SubmitButton type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
        </SubmitButton>
      </form>
    </FeedbackContainer>
  );
};

export default Feedback;
